import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subject, catchError, filter, map, repeat, tap, throwError } from 'rxjs';
import { ItemsApiParams } from '../../../shared/models/deliverables/items-properties.interface';
import { components, operations } from '../api/generated/ix-api.types';
import { IxRestApi } from '../api/ix-rest-api';

export type InterfaceItemDto = components['schemas']['InterfaceItemDto'];

@Injectable({ providedIn: 'root' })
export class ItemsService {
  /** @deprecated Superseded by {@link #ixRestApi} */
  readonly #http = inject(HttpClient);

  readonly #ixRestApi = inject(IxRestApi);

  readonly #refetchItems$ = new Subject<boolean>();

  readonly #items$ = new BehaviorSubject<UNDEFINED<InterfaceItemDto[]>>(undefined);
  /** @deprecated Call {@link getItems} instead. */
  items$ = this.#items$.asObservable().pipe(filter(Boolean));

  /**
   * @deprecated make another call to {@link getItems} instead.
   */
  refetchItems() {
    this.#refetchItems$.next(true);
  }

  /**
   * @deprecated Superseded by {@link getItems}.
   */
  getItemsDeprecated(props: ItemsApiParams) {
    let params = new HttpParams();
    params = props.taskId ? params.set('taskId', props.taskId) : params;
    const url = `/api/profiles/${props.profileType}/${props.profileId}/items`;

    return this.#http.get<InterfaceItemDto[]>(url, { params }).pipe(
      repeat({ delay: () => this.#refetchItems$ }),
      tap(result => this.#items$.next(result)),
      catchError(error => throwError(() => error)),
    );
  }

  getItems(path: operations['getItems']['parameters']['path']) {
    return this.#ixRestApi
      .get({ pathname: '/api/profiles/{profileKind}/{profileId}/items', options: { path } })
      .pipe(
        map(response => response as unknown as (typeof response)[]), // fix type to list until API is corrected with https://dev.azure.com/ochub/IX/_workitems/edit/118703
        catchError(error => throwError(() => error)), // catch & throw makes no sense, but I have no example to drive the error logic so I have to leave it be.
      );
  }
}
